var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.containerComponent,{tag:"component",attrs:{"id":"events","item-name":_vm.$t('events.title'),"request-config":_vm.requestConfig,"filter":_vm.filter},on:{"items-loaded":function($event){return _vm.$emit('items-loaded', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('event-card',{attrs:{"event":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }